



























































































import { Component, Vue ,Prop} from "vue-property-decorator";
import { VueEditor, Quill } from "vue2-editor";
import Content from "@/store/entities/content";
import Ajax from '../../..//lib/ajax';
@Component({
  components: { VueEditor, Quill },
})

export default class ContentUpdate extends Vue {
  @Prop()
  editContent!: Content;
  dialog: boolean = true;
  content:Content=new Content();
  data() {
    return {
    };
  }

  created() {
    this.content=this.editContent;
    }
    async updateContent(){
    console.log(this.content);
    this.updateCont();
  


  }
  async updateCont() {
    var formData = new FormData();
  formData.append('Text', this.content.text);
  formData.append('Title', this.content.title);
  formData.append('ContentType',this.content.contentType.toString());
  formData.append('ImageFile', this.content.imageFile);
  formData.append('OrderNo', this.content.orderNo.toString());
  formData.append('Id', this.content.id);



    const response = await Ajax.put('/api/services/app/Admin/UpdateContent', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });


      Vue.$toast.success("Kayıt Güncellendi");
      this.closeDialog();
  }
openFileInput() {
  const fileInput = this.$refs.fileInput as HTMLInputElement | undefined;
  if (fileInput) {
    fileInput.click();
  }
}

handleFileChange(event) {
  const selectedFile = event.target.files[0];
  if (selectedFile) {
    // Resim seçildiğinde bu kod çalışır
    this.content.imageName="";
    this.content.imageFile=selectedFile;
    const imagePreview = this.$refs.imagePreview as HTMLImageElement | undefined;
    if (imagePreview) {
      // Seçilen resmi önizleme alanında göster
      const reader = new FileReader();
      reader.onload = (e) => {
        if (typeof e.target.result === 'string') {
          imagePreview.src = e.target.result;
        }
      };
      reader.readAsDataURL(selectedFile);
     
    }
  }
}

  


  closeDialog() {
    this.$emit("closed");
  }

  cancelDialog() {
    this.$emit("cancel");
  }
}
